import { createSelector } from '@reduxjs/toolkit';

import { getActiveComponentDesign } from './getActiveComponentDesignSelector';

export const getNextManuallyInsertedPlatePairName = createSelector(getActiveComponentDesign, (design): string => {
  if (!design) throw new Error();

  return `P-${design.component.platePairs.length + 1}`;
});
